module.exports = __webpack_public_path__ + "85055ac089ae6a0c5efb0c99d3642710.svg";